<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, onMounted } from "vue";
import bootstrap from "bootstrap/dist/js/bootstrap";
import DataService from "../../services/data.service";
import EventBus from "../../common/EventBus";
import DataTable from "datatables.net-vue3";
import DataTableLib from "datatables.net-bs5";
import ButtonHtml5 from "datatables.net-buttons/js/buttons.html5";
import print from "datatables.net-buttons/js/buttons.print";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "datatables.net-responsive-bs5";
import JSZip from "jszip";
window.JSZip = JSZip;
pdfMake.vfs = pdfFonts.pdfMake.vfs;
DataTable.use(DataTableLib);
DataTable.use(pdfMake);
DataTable.use(ButtonHtml5);
DataTable.use(print);
import ModalRequest from "./ModalRequest.vue"

const solicitudes = ref([]);

const columns = [
  { data: "nombre_empleado" },
  { data: "nombre_institucion" },
  {
    data: null,
    render: function (data, type, row, meta) {
      let estado = data.nombre_estado;
      let clase = "";
      switch (estado) {
        case "En proceso":
          clase = "badge badge-sm bg-gradient-secondary";
          break;
        case "Revision":
        case "Revisión":
        case "En revision":
        case "En revisión":
        case "En Revision":
        case "En Revisión":
          clase = "badge badge-sm bg-gradient-warning";
          break;
        case "Aceptado":
          clase = "badge badge-sm bg-gradient-success";
          break;
        case "Rechazado":
          clase = "badge badge-sm bg-gradient-danger";
          break;
      }
      return `<span class="${clase}">${estado}</span>`;
    },
  },
  {
    data: null,
    render: function (data, type, row, meta) {
      return `${formatDate(data.horario)}`;
    },
  },
  {
    data: null,
    render: function (data, type, row, meta) {
      if (!data.dias) {
        return "";
      }
      return `${formatDate(data.horario, data.dias - 1)}`;
    },
  },
  { data: "nombre_motivo" },
  { data: "dias" },
];

const button = [
  {
    title: "Reporte de Solicitudes",
    extend: "excelHtml5",
    text: '<i class="fa-regular fa-file-excel"></i> Excel',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Solicitudes",
    extend: "pdfHtml5",
    text: '<i class="fa-regular fa-file-pdf"></i> PDF',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Solicitudes",
    extend: "print",
    text: '<i class="fa-solid fa-print"></i> Imprimir',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Solicitudes",
    extend: "copy",
    text: '<i class="fa-regular fa-file-lines"></i> CVS',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
];

onMounted(() => {
  refreshTable();
});

function formatDate(date, daysToAdd = 0) {
  if (!date) return ""; // Manejar el caso cuando la fecha es undefined o null

  // Parsear la fecha en formato 'YYYY-MM-DD'
  const [year, month, day] = date.split("-");

  // Crear un nuevo objeto Date con la fecha parseada
  const originalDate = new Date(year, month - 1, day);

  // Sumar los días adicionales
  originalDate.setDate(originalDate.getDate() + daysToAdd);

  // Obtener los componentes de la fecha modificada
  const newYear = originalDate.getFullYear();
  const newMonth = originalDate.getMonth() + 1;
  const newDay = originalDate.getDate();

  // Formatear y retornar la nueva fecha
  return `${newDay}-${newMonth < 10 ? "0" : ""}${newMonth}-${newYear}`;
}

const refreshTable = () => {
  DataService.getMisInasistencia().then(
    (response) => {
      solicitudes.value = response.data;
    },
    (error) => {
      const content =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      if (error.response && error.response.status === 403) {
        EventBus.dispatch("logout");
      }

      return content;
    }
  );
};

const createRequest = () => {
  const ModalCreateRequest = new bootstrap.Modal(
    document.getElementById("ModalCreateRequest")
  );
  ModalCreateRequest.show();
};
</script>
<style>
@import "datatables.net-bs5";

.dt-type-numeric {
  text-align: center !important;
}
.dt-paging {
  display: flex;
  float: right;
}
</style>

<template>
  <div class="card">
    <div
      class="card-header px-1 d-flex justify-content-between align-items-center"
    >
      <h6 class="mb-0">Tabla de mis solicitudes</h6>
      <!-- <div>
        <button class="btn m-2 btn-primary" @click="createRequest()">
          Crear Solicitud
        </button>
      </div> -->
    </div>
    <div class="card-body px-1 pt-0 pb-2">
      <div>
        <div class="table-responsive">
          <DataTable
            class="table table-striped table-bordered display"
            :data="solicitudes"
            :columns="columns"
            :options="{
              scrollX: true,
              autoWidth: true,
              dom: 'Bfrtip',
              language: {
                search: 'Buscar',
                ZeroRecords: 'No hay registros',
                info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
                infoFiltered: '(Filtrados de _MAX_ registros.)',
                paginate: {
                  first: '<<',
                  previous: '<',
                  next: '>',
                  last: '>>',
                },
              },
              buttons: button,
            }"
          >
            <thead>
              <tr>
                <th>Personal</th>
                <th>Institución</th>
                <th>Estado</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>Motivo</th>
                <th>Cant. Dias</th>
              </tr>
            </thead>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
  <ModalRequest @request-created="refreshTable" />
</template>
